import { BAR_FURNITURE } from './bar.js';
import { CORE_FURNITURE } from './core.js';
import { GAME_FURNITURE } from './games.js';
import { SINGAPORE_FURNITURE } from './singapore.js';
import type { FurnitureDef } from './types.js';
import { WORK_FURNITURE } from './work.js';
import { ARCADE_FURNITURE } from './arcade.js';
import { PET_FURNITURE } from './pets.js';
import { RARE_FURNITURE } from './rare.js';
import { HOME_FURNITURE } from './home.js';
import { PRIZE_FURNITURE } from './prizes.js';
import { MEDIA_FURNITURE } from './media.js';
import { STADIUM_FURNITURE } from './stadium.js';
import { POOL_FURNITURE } from './pool.js';
import { FESTIVE_FURNITURE } from './festive.js';
import { SPORTS_FURNITURE } from './sports.js';
import { LIMITED_FURNITURE } from './limited.js';
import { STAFF_FURNITURE } from './staff.js';

export * from './types.js';

/**
 * The full catalogue, assembled from each feature's section. Keys are the
 * `kind` stored on placed items, so a kind must never be renamed or reused.
 */
export const FURNITURE: Readonly<Record<string, FurnitureDef>> = Object.freeze(
  mergeSections([
    CORE_FURNITURE,
    BAR_FURNITURE,
    SINGAPORE_FURNITURE,
    GAME_FURNITURE,
    WORK_FURNITURE,
    ARCADE_FURNITURE,
    PET_FURNITURE,
    RARE_FURNITURE,
    HOME_FURNITURE,
    PRIZE_FURNITURE,
    MEDIA_FURNITURE,
    STADIUM_FURNITURE,
    POOL_FURNITURE,
    FESTIVE_FURNITURE,
    SPORTS_FURNITURE,
    LIMITED_FURNITURE,
    STAFF_FURNITURE,
  ]),
);

export type FurnitureKind = string;

export const FURNITURE_KINDS: readonly string[] = Object.freeze(Object.keys(FURNITURE));

function mergeSections(sections: ReadonlyArray<Record<string, FurnitureDef>>): Record<string, FurnitureDef> {
  const merged: Record<string, FurnitureDef> = {};
  for (const section of sections) {
    for (const [kind, def] of Object.entries(section)) {
      if (merged[kind]) throw new Error(`Duplicate furniture kind: ${kind}`);
      merged[kind] = def;
    }
  }
  return merged;
}

export function isFurnitureKind(kind: string): boolean {
  return Object.prototype.hasOwnProperty.call(FURNITURE, kind);
}

/** Definition for a stored kind, or undefined for unknown/retired kinds. */
export function furnitureDef(kind: string): FurnitureDef | undefined {
  return isFurnitureKind(kind) ? FURNITURE[kind] : undefined;
}

/** Furniture rotations are facings; only the four even directions are used. */
export const FURNITURE_ROTATIONS = [0, 2, 4, 6] as const;

export function nextRotation(rotation: number): number {
  return (rotation + 2) % 8;
}
export { HOME_FURNITURE } from './home.js';
